import { FormattedMessage } from 'react-intl';
import { IntlMessage } from '@app/types/locale';

interface FormattedMessageProps {
  data: IntlMessage;
}

export const getFormattedMessage = ({ data }: FormattedMessageProps) => {
  return (
    <FormattedMessage data-formatted-message id={data.id} defaultMessage={data.defaultMessage} />
  );
};
